import React, { ReactElement } from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Stack,
    Typography,
} from '@mui/material';
import { CloseCircleOutlined, DownOutlined } from '@ant-design/icons';
import { useTranslation } from '../../contexts/TranslationContext';
import { SnackbarContentProps } from 'notistack';
import { useTheme } from '@mui/material/styles';
import { AnyResponse } from '../../utils/response';

interface UnknownApiErrorSnackbarProps extends SnackbarContentProps {
    response: AnyResponse | null;
    action: ReactElement;
}

const UnknownApiErrorSnackbar = React.forwardRef(
    (props: UnknownApiErrorSnackbarProps, ref) => {
        const theme = useTheme();
        const { translate } = useTranslation();
        const { response} = props;

        const renderMessage = (message: string, index: number) => {
            return (
                <Typography key={`error-${index}`}>
                    {translate(message)}
                </Typography>
            );
        };

        return (
            <Box ref={ref}>
                <Accordion sx={{ overflow: 'hidden' }}>
                    <AccordionSummary
                        expandIcon={<DownOutlined />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        sx={{ background: theme.palette.error.main }}>
                        <Stack
                            spacing={1}
                            direction="row"
                            alignItems="center"
                            sx={{ mr: 2 }}>
                            <CloseCircleOutlined
                                style={{
                                    fontSize: 18,
                                    color: theme.palette.error.contrastText,
                                }}
                            />
                            <Typography
                                sx={{
                                    fontWeight: 'bold',
                                    color: theme.palette.error.contrastText,
                                }}>
                                {translate('errors.unknown')}
                            </Typography>
                        </Stack>
                    </AccordionSummary>
                    <AccordionDetails sx={{ py: 2 }}>
                        {Object.values(response?.messages ?? {})?.map(
                            renderMessage,
                        )}
                    </AccordionDetails>
                </Accordion>
            </Box>
        );
    },
);
export default UnknownApiErrorSnackbar;
